/* eslint-disable no-param-reassign */
import { environmentsUrls, paramsSoluciones } from '../constants/urlParams';

const urlLibrary = require('../../config/pages/urlLibrary.json');

const urls = JSON.parse(JSON.stringify(urlLibrary));

/**
 * Genera una url dependiendo del entorno donde se ejecuta la aplicacion
 * @param {Object} obj
 * @param {string} obj.contextURL
 * @param {('Fusion'|'Fichas'|'Recomendador')} obj.destination
 * @returns {string}
 */
export const generateUrl = ({ contextURL, destination }) => {
  const urlValid = urls.find(eachUrl => eachUrl.loader.includes(destination));
  const isDev = environmentsUrls.dev.some(eachUrl => contextURL.includes(eachUrl));
  const isQA = environmentsUrls.qa.some(eachUrl => contextURL.includes(eachUrl));
  const isProduction = environmentsUrls.production.some(eachUrl => contextURL.includes(eachUrl));
  let environment = null;
  let urlsToRedirect = [];

  if (isDev) {
    environment = 'dev';
  } else if (isQA) {
    environment = 'qa';
  } else if (isProduction) {
    environment = 'prod';
  }

  if (environment) {
    urlsToRedirect = Object.values(urlValid.pathName[environment]);
  }

  const urlParsed = urlsToRedirect[0].split(':')[0];

  return urlParsed;
};

export const getUrlParams = (url) => {
  if (!url.includes('?')) {
    return null;
  }

  const stringWithParams = url.slice(url.indexOf('?'), url.length).replace('?', '');

  if (!stringWithParams) {
    return null;
  }

  const params = stringWithParams.split('&');

  return params.reduce((obj, eachParam) => {
    const paramSeparated = eachParam.split('=');
    const key = paramSeparated[0];
    const value = paramSeparated[1] || null;
    obj[key] = value;

    return obj;
  }, {});
}


export const getUrlAlias = (url) => {
  const splits = url.split('/');
  const alias = splits[splits.length - 1];
  return alias;
}
